import React, { useState } from 'react'
import ReactCardFlip from 'react-card-flip'

import './styles.scss'

function Flipper(props) {
  const [isFlipped, setIsFlipped] = useState(false)

  const c = isFlipped ? 'active' : ''
  return (
    <div className='flipcontainer'>
      <div
        className='card click ui icon cloud'
        onClick={() => setIsFlipped(!isFlipped)}
      >
        <img src={props.before} />
      </div>
      <div
        className={`card overlay ${c}`}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        <img src={props.after} />
      </div>

      <span>
        Quelle:{' '}
        <a href={props.sourceUrl} target='_blank' rel='noopener noreferrer'>
          {props.sourceText}
        </a>
      </span>
    </div>
  )
}

export default Flipper
